import { Model } from '@lernetz/ts-lib';

export class TopicPageSection extends Model {

    public readonly id: string;
    public readonly name: string;
    public readonly elements: object[];

    public constructor(dto) {
        super( dto );
    }
}
